function DecentralandLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="url(#paint0_linear_8404_3509)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7539 11.7V25.2H24.0039L12.7539 11.7Z"
        fill="url(#paint1_linear_8404_3509)"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.50391 25.2H12.7539V11.7L1.50391 25.2Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.19922 32.4C10.2052 34.659 13.9492 36 17.9992 36C22.0492 36 25.7932 34.659 28.7992 32.4H7.19922Z"
        fill="#FF2D55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.59961 28.8C4.62561 30.159 5.84061 31.374 7.19961 32.4H28.7996C30.1586 31.374 31.3736 30.159 32.3996 28.8H3.59961Z"
        fill="#FC9965"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1479 25.2H1.50391C2.06191 26.487 2.77291 27.693 3.60091 28.8H24.1569V25.2H24.1479Z"
        fill="#FFBC5B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1465 18.9V28.8H32.3995L24.1465 18.9Z"
        fill="url(#paint2_linear_8404_3509)"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.9023 28.8H24.1463V18.9L15.9023 28.8Z" fill="white" />
      <circle cx="24.1484" cy="11.7" r="4.5" fill="#FFC95B" />
      <circle cx="12.7539" cy="6.75" r="2.25" fill="#FFC95B" />
      <defs>
        <linearGradient
          id="paint0_linear_8404_3509"
          x1="18"
          y1="-7.45584"
          x2="-7.45584"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2D55" />
          <stop offset="1" stopColor="#FFBC5B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8404_3509"
          x1="12.7501"
          y1="11.7"
          x2="12.7501"
          y2="25.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A524B3" />
          <stop offset="1" stopColor="#FF2D55" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8404_3509"
          x1="24.1437"
          y1="18.9"
          x2="24.1437"
          y2="28.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A524B3" />
          <stop offset="1" stopColor="#FF2D55" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default DecentralandLogo
